import React, {useState, useRef, forwardRef, useImperativeHandle} from 'react';
import Button from 'devextreme-react/button';
import {useHistory} from 'react-router-dom';
import './index.scss';
import amazonPic from '../../../../assets/amazon.jpg';
import Form, {Item, RequiredRule, Label, ButtonItem} from 'devextreme-react/form';
import storesApi from '../../../../api/stores';
import {Popover} from 'devextreme-react/popover';
import {LoadPanel} from 'devextreme-react/load-panel';
import sessions from '../../../../sessions';

const Amazon = forwardRef((props, ref) => {
    const position = {of: '#employee'};
    const [isloadPanelVisible , setIsloadPanelVisible] = useState(false);
    const [isQuestionBtnOnClick, setisQuestionBtnOnClick] = useState(false);
    const formData = useRef({});
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.id;
    const history = useHistory();

    const QuestionBtnOnClick = () => {
        if(isQuestionBtnOnClick) 
            setisQuestionBtnOnClick(false);
        else 
            setisQuestionBtnOnClick(true);
        }
    const onSubmit = (async(e) => {
        if (e) 
            e.preventDefault();
        
        const {shopName} = formData.current;
        if (shopName) {
            try {
                await storesApi
                    .getOauth("amazon", userId, shopName,auth)
                    .then(res => {
                        window.location.href = res.data.data;
                    })
            } catch (err) {
                console.log(err);
            }
        }
    })

    useImperativeHandle(ref, (e) => ({onSubmit}));

    return (
        <React.Fragment>
            <div id={'amazon-store'}>
                <div className="bridge-header">
                    <img alt="amazonPic" src={amazonPic} className="store-amazon-img logo-size"/>
                    <Button
                        id={'amazon-qbtn'}
                        icon={'fas fa-question-circle'}
                        onClick={QuestionBtnOnClick}/>
                </div>
                <br/>
                <div className={'selling-channel-form'}>
                    <form onSubmit={onSubmit}>
                        <Form
                            formData={formData.current}
                            className="form-field"
                            labelLocation={'left'}
                            validationGroup='group'>
                            <Item
                                dataField="shopName"
                                isRequired={true}
                                editorType="dxTextBox"
                                showClearButton={true}
                                editorOptions={{
                                width: 200,
                                stylingMode: 'filled',
                                placeholder: 'amazon store'
                            }}>
                                <Label text="store name"/>
                                <RequiredRule message="store name is required"/>
                            </Item>
                            <ButtonItem horizontalAlignment="left" //This button help to preventdefault
                                buttonOptions={{
                                text: 'shadowButton',
                                type: 'success',
                                useSubmitBehavior: true,
                                visible: false
                            }}/>
                        </Form>
                    </form>
                </div>
            </div>
            <div className={'bridge-footer'}>
                <p className={'etsy-disclaimer'}>Amazon Integration will available to you soon</p>
            </div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={!isloadPanelVisible}
                visible={isloadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                closeOnOutsideClick={false}/>
            <Popover
                target="#amazon-qbtn"
                position="right"
                width={200}
                visible={isQuestionBtnOnClick}
                onHiding={() => {
                setisQuestionBtnOnClick(false)
            }}
                closeOnOutsideClick={true}>
                <div>
                    <p>Check Your store Name
                        <a target="_blank" href={'https://sellercentral.amazon.com/home?'}> here </a>
                    </p>
                </div>
            </Popover>
        </React.Fragment>
    );
})

export default Amazon;